import { render, staticRenderFns } from "./ModuleBranch.vue?vue&type=template&id=346d1798&scoped=true&"
import script from "./ModuleBranch.vue?vue&type=script&lang=ts&"
export * from "./ModuleBranch.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleBranch.vue?vue&type=style&index=0&id=346d1798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346d1798",
  null
  
)

export default component.exports